enum EconomicSectors {
	agroindustrial,
	food,
	automotive,
	building,
	electronics,
	industry,
	telecommunication,
	textile,
	tics,
	transport,
	other,
}

const StringsEconomicSectors = ['Agroindustrial','Alimentos','Automotriz','Construcción','Electrónica',
	'Industria','Telecomunicaciones','Textil','TICs','Transporte','Otro'];

export enum BusinessActivities {
	manufacture,
	distribution,
	retail,
	merchant,
	services,
	other,
}

const StringsBusinessActivities = ['Manufactura', 'Distribución','Retail (Venta al por menor)',
	'Comercialización', 'Servicios', 'Otro'];

const States = {
	AGU: 'Aguascalientes',
	BCN: 'Baja California',
	BCS: 'Baja California Sur',
	CAM: 'Campeche',
	CHH: 'Chihuahua',
	CMX: 'Ciudad de México',
	COA: 'Coahuila',
	COL: 'Colima',
	DUR: 'Durango',
	GUA: 'Guanajuato',
	GRO: 'Guerrero',
	HID: 'Hidalgo',
	JAL: 'Jalisco',
	MIC: 'Michoacan de Ocampo',
	MOR: 'Morelos',
	MEX: 'México',
	NAY: 'Nayarit',
	NLE: 'Nuevo Leon',
	OAX: 'Oaxaca',
	PUE: 'Puebla',
	QUE: 'Queretaro',
	ROO: 'Quintana Roo',
	SLP: 'San Luis Potosi',
	SIN: 'Sinaloa',
	SON: 'Sonora',
	TAB: 'Tabasco',
	TAM: 'Tamaulipas',
	TLA: 'Tlaxcala',
	VER: 'Veracruz',
	YUC: 'Yucatan',
	ZAC: 'Zacatecas',
};

enum CompanySize  {
	big,
	medium,
	small,
	micro
}

const StringsCompanySize = [
	'Grande (250+)',
	'Mediana (100 - 250)',
	'Pequeña (10 - 100)',
	'Micro (0 - 10)'
];

export const ReportTexts = {
	A : {
		name: 'Autodiagnóstico de Ciclo Productivo',
		1: {
			opportunities: '• Optimizar el uso de materiales:  reducir su uso,  utilizar materiales reciclados, abundantes localmente,  biodegradables, reducir su intensidad en producto y reinsertar desperdicio.\n' +
				' • Seleccionar los materiales que garanticen  una cadena de suministro sustentable. Por ejemplo, usar nutrientes biológicos en lugar de técnicos, usar materiales reciclados, reducir el uso de materiales escasos, o sustancias tóxicas, y utilizar materiales que generan menos emisiones en ciclos extractivos o productivos.\n' +
				'• Aprovechar la simbiosis industrial, es decir, el intercambio físico de materiales entre empresas; los desechos de una compañía se convierten en el recurso para otra compañía.',
			benefits: '• Se pueden reducir costos gracias a la reducción del uso de  materia prima, al igual que los costos de distribución, y se reduce espacio de almacenamiento, con lo que se puede lograr un ahorro considerable para el productor y consumidor.\n' +
				'• La reputación de la empresa puede beneficiar del uso óptimo de materiales\n' +
				'• Se reduce el material enviado a vertedero o tratamiento\n' +
				'• Se producen menos emisiones de carbono y se reduce la  contaminación de la empresa',
			considerations: '• La durabilidad del producto y/o del empaque podría reducirse \n' +
				'• El costo de los materiales podría aumentar con el cambio de materiales'
		},
		2: {
			opportunities: '• Al mejorar el ciclo de vida del producto se puede extender su vida útil y aumentar la eficiencia de su funcionamiento para disminuir el consumo de energía y recursos a lo largo del tiempo. Sin embargo, si el producto consume recursos, la vida útil del producto debe coincidir con la duración de la eficiencia del producto. \n' +
				'• Se puede contar con un diseño fiable, eficiente en el uso de recursos y de alta calidad.',
			benefits: '• El costo total, inlcuyendo la propiedad del proyecto, disminuye para el cliente\n' +
				'• Se reduce el impacto ambiental total del producto',
			considerations: '• Se tiene que tomar en cuenta que esto podría ocasionar que el producto canibalice las ventas\n' +
				'• La vida útil del producto es determinada por el usuario\n' +
				'• Considerar la inversión que se requiere para realizar los cambios en el producto'
		},
		3: {
			opportunities: 'El mantenimiento y reparación es una actividad crítica que se lleva a cabo en la fase de uso para prolongar el ciclo de vida de los poductos. Las ofertas de mantenimiento pueden incluir:\n' +
				'• Reparación y cambio de refacción\n' +
				'• Servicio\n' +
				'• Diagnóstico: en el sitio y remoto\n' +
				'• Soporte técnico - documentación y personal\n' +
				'• Instalación\n' +
				'• Garantía (cambios o devoluciones)\n' +
				'\n' +
				'Algunas oportunidades que se puede aprovechar desde el diseño de producto son:\n' +
				'• Fácil acceso a las piezas.\n' +
				'• Diagnóstico de fallas\n' +
				'• Manipulación y montaje de piezas.\n' +
				'• Intercambiabilidad de piezas.\n' +
				'• Acceso a los puntos de lubricación.\n' +
				'• Características de redundancia\n' +
				'• Ajustes finales\n' +
				'• Identificación de componentes y clientes potenciales.\n' +
				'• Conexiones eléctricas reducidas\n' +
				'• Seguridad para los técnicos.',
			benefits: '• Se puede prolongar la vida útil del producto \n' +
				'• Es la forma más eficiente de devolver el sistema a las condiciones de trabajo.\n' +
				'• El producto puede obtener una ventaja competitiva\n' +
				'• Podría generarse de 3 a 4 veces más de facturación que con la compra original',
			considerations: '• El servicio al cliente es crítico\n' +
				'• La competencia en el mercado\n' +
				'• La calidad, el costo y la velocidad de la reparación\n' +
				'• La tecnología potencialmente requerida para realizar la reparación'
		},
		4: {
			opportunities: '• La reutilización o reventa extiende la vida útil del producto. Los productos revendidos pueden ser productos completos o componentes del producto. En este caso podría considerarse como servicios adicionales las pruebas, certificación y garantía del producto.\n' +
				'• Para lo anterior, el diseño del producto debe garantizar que es durarero y que todavía tenga valor una vez que el cliente quiera cambiarlo.',
			benefits: '• Existe un incentivo que otros querrán aprovechar al revenderlo para generar ganancias extras\n' +
				'• Es posible ofrecer actualizaciones y mejorar las relaciones con los clientes.\n' +
				'• Se evita que se utilicen más materiales y energía para los nuevos productos.',
			considerations: '• La magnitud de la oferta y de la demanda \n' +
				'• Los efectos en la calidad y reputación de la empresa\n' +
				'• La transparencia de los precios\n' +
				'• La competitividad del precio\n' +
				'• La competencia en el mercado'
		},
		5: {
			opportunities: 'Existe la oportunidad que desde el diseño del producto se considere lo siguiente: \n' +
				'• Facilidad de desarmado\n' +
				'• Número de conexiones\n' +
				'• Herramientas necesarias para desarmar\n' +
				'• Daño causado al desarmar\n' +
				'• Facilidad de reensamblaje\n' +
				'• Facilidad de identificación\n' +
				'• Potencial de actualización\n' +
				'• Modularidad parcial',
			benefits: '• La remanufactura puede ser dos veces más rentable que la manufactura\n' +
				'• Se obtienen reconocimientos "verdes"\n' +
				'• Es posible reducir la energía, los materiales y los residuos en el proceso de producción',
			considerations: '• Se debe lograr que el precio sea competitivo para el cliente.\n' +
				'• El suministro central y la calidad con la que se reacondiciona o remanufactura el producto o sus piexas\n' +
				'• La variabilidad de proceso para el reacondicionado o remanufacturado'
		},
		6: {
			opportunities: '• En lugar de vender productos convencionalmente, es posible ofrecer productos como un servicio. El proveedor generalmente tiene la propiedad del producto durante todo el ciclo de vida y puede administrar el producto a través del diseño, uso, mantenimiento, reutilización, remanufactura y reciclaje. A continuación se mencionan algunas formas para utilizar el productos como servicio:\n' +
				'- Pago por unidad de servicio: el cliente paga cada vez que usa el servicio\n' +
				'- Alquiler del producto: el cliente paga por usar el producto, normalmente por un período corto de tiempo\n' +
				'- Arrendamiento del producto: el cliente tiene acceso continuo al producto, generalmente por un período de tiempo más largo\n' +
				'- Agrupación de productos: cuando varios clientes pueden usar el producto simultáneamente\n' +
				'\n' +
				'• En el diseño del producto debe considerarse cada ciclo de vida del mismo:\n' +
				'- El uso\n' +
				'- Mantenimiento / reparaciones\n' +
				'- Restauración / renovación\n' +
				'- Reciclaje',
			benefits: '• Se cumplen mejor las necesidades de los clientes\n' +
				'• Se construyen mejores relaciones con los clientes\n' +
				'• El proceso de innovación es más rápido\n' +
				'• Se reducen las barreras de entrada para los clientes, ya que no necesitan comprar\n' +
				'• Se reduce el uso de materias primas, energía y se generan menosresiduos',
			considerations: '• Hay riesgo de cumplir con la disponibilidad adecuada o la calidad / rendimiento adecuado\n' +
				'• Se debe tomar en cuenta la inversión necesaria para crear el servicio y conservar la propiedad\n' +
				'• Es necesario gestionar nuevas áreas de la cadena de valor\n' +
				'• El uso irresponsable del producto puede causar daños'
		},
		7: {
			opportunities: '• Los productos deben estar diseñados para garantizar que los materiales puedan separarse y reutilizarse al final de su vida útil.',
			benefits: '• Se pueden reducir los desechos que van a la basura\n' +
				'• Se conservan los recursos naturales y es posible extender su disponibiliad.\n' +
				'• Se reduce el uso de materiales vírgenes y los costos asociados para su obtención\n' +
				'• Se obtienen reconocimientos "verdes"',
			considerations: '• Tomar en cuenta los requisitos de legislación, según el sector (especial atención en alimentos)\n' +
				'• Los costo implicados en el cambio de diseño\n' +
				'• El rediseño podría afectar la funcionalidad del producto, por lo que se debe revisar el desempeño de los materiales reciclados y su debido acondicionamiento'
		},
	},
	B : {
		name: 'Materiales y servicios auxiliares',
		1: {
			opportunities: '• Implementar medidas de ahorro de agua. En  lo posible, utilizar aguas de reuso o tratadas.\n' +
				'• Alto potencial de simbiosis industrial para el tratamiento de agua,  y gestión de los recurosos hidricos\n' +
				'• Generación de biogas por el tratamiento de aguas con altas cargas orgánicas',
			benefits: '•  Se reduce los riesgo por estrés hídrico de la zona\n' +
				'•  Se obtienen reconocimiento "verdes", mejorandola reputación por la sustentabilidad de la empresa\n' +
				'• Se reducen los costo de operación y por pago del servicio de agua\n',
			considerations: '• La inversión necesaria para la implementación de sistemas para el ahorro de agua, plantas de tratamiento, mejora de la infraestructura, etc.'
		},
		2:{
			opportunities: '• Implementar sistemas de seperación, posible valorización y/o deshecho adecuado de residuos\n' +
				'• Se reduce la generación de emisiones y el  impacto al medio ambiente ambiente\n' +
				'• Es posible explotar y hacer aprovechamiento de simbiosis industrial, a traves de la valorización de resiudos por otros actores',
			benefits: '• Existe la oportunidad de obtener certificados oficiales emitidos por las autoridades competentes por un manejo adecuado de residuos (e.g. Industria Limpia)\n' +
				'• Mejor reputación con el cliente. Se pueden obtener reconocimientos o certificaciónes "verdes"\n' +
				'• Es posible generar más ingresos si se aprovecha el reciclado y la simbiosis industrial\n' +
				'• Ventaja competitiva al tener un manejo adecuado de residuos',
			considerations: '• Es necesario hacer una inversión para implementar un sistema para el manejo adecuado de residuos: estudios, pago por servicios profesionales, capacitación del personal, compra de materiales, etc.'
		},
		3: {
			opportunities: '• Se recomienda implementar un sistema de gestión y monitoreo de las fuentes de energía utilizadas para la empresa, inlcuyendo iniciativas de conservación o eficiencia energética.\n' +
				'• Utilizar energías renovables, y promover el autoabastecimiento.\n' +
				'• Aprovechar las oportunidades de simbiosis industrial en materia energética (recircular vapor, plantas de energía en conjunto, etc.)\n' +
				'• Se reduce significativamente la generación de emisiones de carbono, atmosfericas, y otros impactos al ambiente\n',
			benefits: '• Es posible generar más ingresos si se aprovecha la simbiosis industrial por el intercambio de energía (como vapor, combustibles o energía eléctrica)\n' +
				'• Se obtienen reconocimientos "verdes" y mejora la reputación.\n' +
				'• Se reducen los costos por el pago de los energéticos, aun de mayor manera al usar fuentes renovables\n' +
				'•  Se reduce el riesgo por posibles crisis de comsbutibles (precios o de abasto)',
			considerations: '• La implementación de un sistema de gestión y monitoreo energética requiere una inversión para ponerse en marcha: estudios, pago por servicios profesionales, capacitación del personal, etc.'
		},
	},
	C : {
		name: 'Gestión interna y ecosistema de la Economía Circular',
		1: {
			opportunities: '• Se recomienda obtener capacitación profesional en economía circular y asesoría para su adopción al interior de la empresa, al mismo tiempo de capacitar a los integrantes de la asociación ',
			benefits: '• Se facilita la adopción de la economía circular tanto de manera vertical como horizontal al interior de la organización\n' +
				'• Se adoptan conductas y una mentalidad de circularidad entre los integrantes de la organización ',
			considerations: '• Si bien es el primer acercamiento, es importante considerar el tiempo y la inversión necesaria para capacitar a todo el personal de la organización '
		},
		2: {
			opportunities: '• Es posible generar nuevas ideas y encontrar oportunidades para explotar el potencial de aprovechamiento de sistemas de economía circular\n' +
				'• Se recomienda revisar y en su caso actualizar periódicamente las políticas internas y planes de gestión de economía circular (por ejemplo, cada 5 años) \n' +
				'• Tomando en cuenta el tamaño de la empresa, se sugiere que exista un área o cargo responsable de las políticas de economía circular y de su cumplimiento',
			benefits: '• Se obtienen mejoras en la organización interna, con responsabilidades específicas, medidas e indicadores de cumplimiento, y se facilita la adopción de nuevas tecnologías y procesos\n' +
				'• Se cuenta con políticas internas actualizadas, modernas y con estándares de cumplimiento que aumentan el valor de la empresa en el mercado\n' +
				'• Mejora la reputación de la empresa en el mercado\n' +
				'• Se obtienen reconocimientos "verdes"\n' +
				'• Se obtienen ventajas competitivas por encima de la competencia\n' +
				'• Se puede aumentar el precio del producto justificadamente, logrando mayores ingresos\n' +
				'\n',
			considerations: '• Es necesario invertir en la creación de las políticas internas y el plan de gestión, ya que estos deben ser elaborados por profesionales en la materia\n' +
				'• La organización debe adoptar estas políticas de manera integral dentro de sus diferentes procesos, por lo que se deberá capacitar a cada unas de las áreas involucradas'
		},
		3: {
			opportunities: '• Se involucra a los integrantes de la organización en la toma de decisiones sobre los procesos y procedimientos de la empresa\n' +
				'• Es posible explorar oportunidades para la adopción de prácticas y tecnología que promueva la economía circular en los procesos y procedimientos de la organización\n' +
				'• Se recomienda revisar y en su caso actualizar periódicamente las políticas internas y planes de gestión de economía circular (por ejemplo, cada 5 años) ',
			benefits: '• La participación de los integrantes no solo los integra en la toma de decisiones de la organización, sino que también aporta el enfoque y perspectiva desde todos los niveles y posiciones de trabajo\n' +
				'• La organización puede garantizar altos estándares en la práctica y tecnología de sus procedimientos, lo que le da valor adicional dentro de la competencia \n' +
				'• Un alto nivel de adopción es un  diferenciador ante la competencia que puede dar lugar a obtener mayores ingresos',
			considerations: '• Dependiendo del proceso o procedimiento, se puede requerir de una inversión para adoptar prácticas o tecnologías que promuevan la economía circular en la empresa'
		},
		4:{
			opportunities: '• Se recomienda generar alianzas con proveedores y socios industriales que faciliten faciliten la adopción de la economía circular en la organización, ya que hace posible explotar nuevas oportunidades de negocio y hacer un aprovechamiento de la simbiosis industrial\n' +
				'• Este tipo de alianzas puede aumentar la calidad del producto desde la cadena de producción',
			benefits: '• Facilita la adopción y el tránsito hacia esquemas, políticas y procesos de economía circular en la organización \n' +
				'• Contar con proveedores y socios industriales que ya cuenten con mecanismos de economía circular puede generar ahorros y sustituir los cambios que se tendrían que hacer prácticas y tecnología de la empresa\n' +
				'• Se generan oportunidades para ampliar servicios, contar con nuevos productos o líneas de negocio, lo que podría aumentar los ingresos de la organización\n' +
				'• Aprovechar la simbiosis industrial puede disminuir las emisiones de la empresa',
			considerations: '• Puede ser difícil llegar a contactar a un  proveedor o socio industrial que ya cuenten con mecanismos de economía circular que sea económicamente accesible y que no aumente considerablemente el costo del producto '
		},
		5: {
			opportunities: '• Se aumenta la adopción de la economía circular al integrar a los clientes en la cadena de valor del producto\n' +
				'• Se pueden explorar nuevos segmentos de la población a los que se dirije el producto/servicio\n' +
				'• La empresa puede encontrar nuevas oportunidades de inversión para financiar nuevas líneas de negocio\n',
			benefits: '• Facilita la adopción y el tránsito hacia esquemas, políticas y procesos de economía circular en la organización \n' +
				'• Se generan oportunidades para ampliar servicios, contar con nuevos productos o líneas de negocio, lo que podría aumentar los ingresos de la organización\n' +
				'• Se obtienen reconocimientos "verdes"\n' +
				'• La reputación de la empresa puede mejorar considerablemente y darse a conocer\n' +
				'• Si se identifica correctamente el público objetivo para el cual se dirige el producto, existe oportunidade de que aumenten las ventas \n' +
				'• Si los clientes dan seguimiento y continuan con la circularidad del producto se pueden disminuir de las emisiones de la empresa\n',
			considerations: '• Se pueden elevar los costos en publicidad, imagen, mercado, marketing, etc.\n' +
				'• No todos los clientes pueden integrarse completamente a los esquemas de economía circular, lo que compromete el propósito y circularidad del producto\n' +
				'• Es difícil encontrar la manera de garantizar que los clientes den continuidad a la circularidad del producto'
		},
	}
};

export const CatalogsUserForm = {
	companySizes: {
		strings: StringsCompanySize,
		values: Object.values(CompanySize).filter(value => typeof value === 'number')
	},
	businessActivities: {
		strings: StringsBusinessActivities,
		values: Object.values(BusinessActivities).filter(value => typeof value === 'number')
	},
	economicSectors : {
		strings: StringsEconomicSectors,
		values: Object.values(EconomicSectors).filter(value => typeof value === 'number')
	},
	states: States
}

